import type { NodeConnections } from '../types/nodeConfig';
import type { ProjectDocument } from '../types/project';

export function buildNodeConnections(
  document: ProjectDocument,
  nodeId: string,
): NodeConnections {
  const names = new Map(document.nodes.map((n) => [n.id, n.name]));

  const incoming = document.routes
    .filter((r) => r.to_node_id === nodeId)
    .map((r) => ({
      route_id: r.id,
      route_name: r.name,
      peer_node_id: r.from_node_id,
      peer_node_name: names.get(r.from_node_id) ?? 'Unknown',
    }));

  const outgoing = document.routes
    .filter((r) => r.from_node_id === nodeId)
    .sort((a, b) => (a.output_index ?? 0) - (b.output_index ?? 0))
    .map((r) => ({
      route_id: r.id,
      route_name: r.name,
      peer_node_id: r.to_node_id,
      peer_node_name: names.get(r.to_node_id) ?? 'Unknown',
    }));

  return { incoming, outgoing };
}
